import type { LpuDoctor } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

/**
 * Поле ФИО для перевода: девичья фамилия, иначе полное, иначе короткое.
 */
export default function getDoctorNameField(doctor: LpuDoctor): 'fio_maiden' | 'fio' | 'fio_short' {
  if (doctor.fio_maiden) {
    return 'fio_maiden'
  }

  if (doctor.fio) {
    return 'fio'
  }

  return 'fio_short'
}
